const STORAGE_KEY = "waLoginRedirectPath";

export const useLoginRedirectPath = () => {
  const setLoginRedirectPath = (path: string) =>
    sessionStorage.setItem(STORAGE_KEY, path);
  const getLoginRedirectPath = () => sessionStorage.getItem(STORAGE_KEY);
  const clearLoginRedirectPath = () => sessionStorage.removeItem(STORAGE_KEY);

  return {
    getLoginRedirectPath,
    setLoginRedirectPath,
    clearLoginRedirectPath,
  };
};
